import { render, staticRenderFns } from "./RenderAvatar.vue?vue&type=template&id=aabedf0e&scoped=true"
import script from "./RenderAvatar.vue?vue&type=script&lang=js"
export * from "./RenderAvatar.vue?vue&type=script&lang=js"
import style0 from "./RenderAvatar.vue?vue&type=style&index=0&id=aabedf0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabedf0e",
  null
  
)

export default component.exports